<template>
    <v-container fluid  ma-0 pb-0>
        <template  v-if="type !== 'details'">
            <v-toolbar flat color="white">
                <!--Employee FORM-->
                <template v-if="type === 'form'">
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                </template>
                <!--Employee VIEW TABLE-->
                <template v-if="type === 'view'">
                    <v-toolbar-title>
                        Employees Table
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    
                    <template v-if="Array.isArray(chartSeries) && chartSeries.length">
                        <v-label>Types Breakdown</v-label>
                        <headerChartBar :cSeries="chartSeries"></headerChartBar>
                        <v-spacer></v-spacer>
                    </template>
                    
                    <responsiveButton setTo="/orgWorkSpace/employee/add"
                                      setColor="blue"
                                      setDefaultIcon="mdi-plus"
                                      setSmallIcon="mdi-plus-circle-outline"
                    >
                        Employee
                    </responsiveButton>
                </template>
                <!--Employee DocumentFile-->
                <template v-if="type === 'documentFile'">
                    <v-toolbar-title>Edit employee document files</v-toolbar-title>
                </template>
                <!--Employee type-->
                <template v-if="type === 'addType'">
                    <v-toolbar-title >Employee Categories Table </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <responsiveButton setTo="/orgWorkSpace/group-type/employee/add/"
                                      setColor="blue"
                                      setDefaultIcon="mdi-plus"
                                      setSmallIcon="mdi-plus-circle-outline"
                    >
                        Add Employee Category
                    </responsiveButton>
                </template>
            </v-toolbar>
            <v-divider class="my-0 mx-6"></v-divider>
        </template>
        <!--Details View-->
        <template v-else>
            <v-row align="center" no-gutters>
                <v-col class="pb-0">
                    <v-card elevation="1">
                        <v-card-actions>
                            <v-bottom-navigation
                                    grow
                                    class="elevation-0"
                                    :value="activeBtn"
                                    color="blue"
                            >
                                <v-btn
                                :to="{name: EMPLOYEES.DOCUMENTS.route}">
                                    <span>{{EMPLOYEES.DOCUMENTS.text}}</span>
                                    <v-icon>{{EMPLOYEES.DOCUMENTS.icon}}</v-icon>
                                </v-btn>

                                <v-btn
                                :to="{name: EMPLOYEES.CLIENTS.route}">
                                    <span>{{EMPLOYEES.CLIENTS.text}}</span>
                                    <v-icon>{{EMPLOYEES.CLIENTS.icon}}</v-icon>
                                </v-btn>

                                <v-btn
                                        :to="{name: EMPLOYEES.REPORTS.route}">
                                    <span>{{EMPLOYEES.REPORTS.text}}</span>
                                    <v-icon>{{EMPLOYEES.REPORTS.icon}}</v-icon>
                                </v-btn>
                            </v-bottom-navigation>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
    import { TOKEN } from '@/shared/enums/TokenSeparator';
    import alertEventBus from '@/eventBus/AlertEventBus';
    import headerChartBar from '@/components/orgApps/charts/headerChartBars';
    import {EMPLOYEES} from '@/shared/enums/SubViewPathName';
    const responsiveButton = ()=> import( '@/components/common/mobile/Button');

    export default {
        name: "EmployeeHeader",
        props: ["hType", "id", "path_view"],
        components: {
            responsiveButton,
            headerChartBar
        },
        data() {
            return {
                type: this.hType,
                path_id: this.id,
                activeBtn: this.selectSubView(),
                employee:{
                    clients: []
                },
                cognitoUser: {
                    attributes: {},
                    address:{}
                },
                chartSeries: []
            }
        },
        watch:{
            id (value){
                this.path_id = value;
            },
             async hType(value){
                this.type = value;
                if(this.type === 'details')  {
                     await this.loadData()
                }
            },
        },
        computed:{
            formTitle () {
                return this.id !== undefined ? 'Edit employee' : 'New employee';
            },
            EMPLOYEES(){
                return EMPLOYEES;
            }
        },
        methods:{
            async loadData() {
                try {
                    //call store employee
                    await this.$store.dispatch('getEmployee', {id: this.path_id});
                    let emp = this.$store.getters.getEmployee;

                    if(!!!emp){
                        throw {message: 'Not valid employee found for id:'+ this.path_id};
                    }

                    this.employee = emp;

                    let date = new Date(this.employee.systemCreatedDateTime);
                    this.employee.fromattedCreatedDate = date.toDateString();

                    let user = this.$store.getters.getCognitoUser;
                    if(user === null || user.Username !== emp.cognitoUsername) {
                        await this.$store.dispatch('getCognitoUser', {username: this.employee.cognitoUsername});
                        user = this.$store.getters.getCognitoUser;
                    }
                    if(user){
                        this.cognitoUser.username = user.Username;
                        for(let property in user.UserAttributes){
                            this.cognitoUser.attributes[user.UserAttributes[property].Name] = user.UserAttributes[property].Value;
                        }

                        this.cognitoUser.attributes.phone_number = this.cognitoUser.attributes.phone_number.replace(/\+1/,'');
                        let tempAddress = this.cognitoUser.attributes.address.split(TOKEN);

                        this.cognitoUser.address = {
                            addrs: tempAddress[0] !== undefined ? tempAddress[0] : '',
                            apt: tempAddress[1] !== undefined ? tempAddress[1] : '',
                            city: tempAddress[2] !== undefined ? tempAddress[2] : '',
                            state: tempAddress[3] !== undefined ? tempAddress[3] : '',
                            zip_code:tempAddress[4] !== undefined ? tempAddress[4] : ''
                        };
                    }
                } catch (e) {
                    //set alert
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }
            },
            async getEmployeesChart() {
                let details = this.$store.getters['getEmployeeDetails'];
                // if empty
                if (
                  details !== null ||
                  (Object.keys(details).length === 0 && details.constructor === Object)
                ) {
                  //going backend
                  try {
                    await this.$store.dispatch(`getEmployeeDetails`);
                    details = this.$store.getters[`getEmployeeDetails`];
                  } catch (e) {
                    //set alert
                    alertEventBus.setAlert({ type: "error", msg: e.message });
                    return;
                  }
                }

                let dataSeries = [];

                if (!!details && !!details.counters && !!details.counters.typeName) {
                  const { typeName } = details.counters;
                  const reducer = (a, c) => a + c;

                  dataSeries = Object.keys(typeName).map((k) => ({
                    name: k,
                    data: [Object.values(typeName[k].status).reduce(reducer)],
                  }));
                  this.chartSeries = dataSeries;
                }
            },
            selectSubView(){
                if(this.path_view === EMPLOYEES.DOCUMENTS.text){
                    return 0;
                }

                if(this.path_view == EMPLOYEES.CLIENTS.text){
                    return 1;
                }

                if(this.path_view == EMPLOYEES.REPORTS.text){
                    return 2;
                }
            }
        },
        async created() {
            this.getEmployeesChart();
            if(this.type === 'details') {
                await this.loadData();
            }
        },
    }
</script>

<style scoped>

</style>
